<script>
/* eslint no-unused-vars: 'off' */
import myAnalysis from '@/components/myAnalysis/myAnalysis.vue';
import current from '@/scripts/current';

export default {
    props: ['router', 'forReport'],
    components: {
        myAnalysis
    },
    render(h) {
        const vm = this;
        const v = current.selectionModel.v;
        let cells = [
            {
                name: 'Row Variable',
                display: v.row.toString()
            },
            {
                name: 'Column Variable',
                display: v.column.toString()
            },
            {
                name: 'Control Variable(s)',
                display: [v.control1.toString(), v.control2.toString()]
                    .filter((v) => isNotEmpty(v))
                    .join(', ')
            }
        ];
        if (vm.forReport) cells = cells.filter((c) => isNotEmpty(c.display));
        let myAnalysis = h('my-analysis', {
            ref: 'myAnalysis',
            props: {
                router: vm.router,
                forReport: vm.forReport,
                tableType: 'Cross Tabulation',
                cells
            }
        });
        return myAnalysis;
    },
    data: function () {
        return {};
    },
    methods: {}
};

function isNotEmpty(s) {
    return s && s.length > 0;
}
// function formatControlVariables(v) {
//   return [v.control1.toString(), v.control2.toString()]
//     .filter((v) => v && v.length > 0)
//     .join(", ");
//   //   var control1Display = v.control1.toString();
//   //   var control2Display = v.control2.toString();
//   //   var display = control1Display;
//   //   if (control2Display.length > 0) display = display + ", " + control2Display;
//   //   return display;
// }
</script>

<style scoped>
</style>